/**
 * Adds the definite article "the" to the water name if needed.
 * For now only streams get the definite article.
 *
 * @param waterName - The name of the water body.
 * @param waterType - The type of the water body, as defined in the WaterTypes enum.
 * @returns The water name prefixed with "the" if the water type is a stream, otherwise returns the original water name.
 */
import { WaterTypes } from '../../generated/graphql';

export const addDefiniteArticleToWaterName = (waterName: string, waterType: WaterTypes): string => {
  switch (waterType) {
    case WaterTypes.stream:
      return `the ${waterName}`;
    default:
      return waterName;
  }
};
